import logger from './logger';

// `window.axios` is the authenticated instance set up in entrypoints/dashboard.js
// (carries devise-token-auth headers), same pattern as the translation feature.
const http = () => window.axios;

const base = (accountId, conversationId) =>
  `/api/v1/accounts/${accountId}/conversations/${conversationId}/ai_assist`;

// Kick off a draft. Returns { request_id } used to correlate streamed tokens
// and to abort. The actual draft text arrives over ActionCable, not here.
export const requestDraft = async ({ accountId, conversationId }) => {
  const { data } = await http().post(`${base(accountId, conversationId)}/draft`, {});
  logger.info('api.draftRequested', { conversationId });
  return data;
};

// Best-effort stop of an in-flight draft.
export const abortDraft = async ({ accountId, conversationId, requestId }) => {
  const { data } = await http().post(`${base(accountId, conversationId)}/abort`, {
    request_id: requestId,
  });
  logger.info('api.draftAborted', { conversationId, requestId });
  return data;
};
